export default {
  init() {

    /**
     * Sticky nav
     */
    var stickyNav = function() {
      // Hide Header on on scroll down
      var didScroll
      var lastScrollTop = 0
      var delta = 5
      var header = $('#nav-header')
      var boxShadowOffset = 4

      $(window).scroll(function () {
        didScroll = true
      })

      setInterval(function () {
        if (didScroll) {
          hasScrolled()
          didScroll = false
        }
      }, 250)

      function hasScrolled() {
        var st = $(window).scrollTop()

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta)
          return

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st >= header.outerHeight() + boxShadowOffset) {
          // Scroll Down
          header.removeClass('nav-down').addClass('nav-up')
        } else {
          // Scroll Up
          if (st + $(window).height() < $(document).height()) {
            header.removeClass('nav-up').addClass('nav-down')
          }
        }

        if (st > delta) {
          header.addClass('nav-shadow')
        } else {
          header.removeClass('nav-shadow')
        }

        if (st <= header.outerHeight() + boxShadowOffset) {
          header.removeClass('nav-down')
        }

        lastScrollTop = st
      }
    }

    /**
     * Burger menu (mobile)
     */
    $('#burger-menu').on('click', function(e) {
      e.preventDefault();
      $('.nav-primary').toggleClass('hidden');
      $(this).toggleClass('open');
    });

    /**
     * Clickable tiles
     */
    let clickableTiles = function() {
      let links = $('.blocks-gallery-item > figure > figcaption a')
      links.each(function() {
        let href = $(this).attr('href')
        let target = $(this).attr('target')
        let item = $(this).parents('.blocks-gallery-item')
        item.addClass('is-linked')
        item.on('click', function(e) {
          e.preventDefault()
          if (target === '_blank') {
            window.open(href)
          } else {
            location.href = href
          }
        })
      })
    }

    /**
     * Accordion
     */
    let accordion = function() {
      $('.accordion-body').each(function() {
        $(this).slideToggle()
      })
      $('.accordion-head').on('click', function(e) {
        e.preventDefault()
        $(this).next().slideToggle()
      })
    }

    /**
     * Init functions
     */
    stickyNav()
    clickableTiles()
    accordion()
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js